<template>
  <main class="mt-5">
    <div class="card mt-3">
      <div class="card-header border-0">
        <h5 class="card-title font-bold py-3">جزئیات</h5>
        <div style="flex: 1"></div>
        <Back url="/admin/contradictions" />
      </div>
      <div class="row col-12 mr-2">
        <div class="col-4">
          <span>شناسه : </span>
          <span class="font-weight-bold">{{ store_contradiction.id }}</span>
        </div>
        <div class="col-4">
          <span>انبار : </span>
          <span class="font-weight-bold">{{
            store_contradiction.store.label
          }}</span>
        </div>
        <div class="col-4">
          <span>تعداد کل درخواست ها: </span>
          <span class="font-weight-bold">{{
            store_contradiction.total_requested
          }}</span>
        </div>
      </div>
      <div class="row col-12 mr-2 mt-3">
        <div class="col-4">
          <span>تعداد مغایرت: </span>
          <span class="font-weight-bold">{{
            store_contradiction.items_count
          }}</span>
        </div>

        <div class="col-4">
          <span>زمان ثبت: </span>
          <span class="font-weight-bold">{{
            store_contradiction.created_at | persianDate
          }}</span>
        </div>
      </div>
    </div>
    <div class="card mt-3">
      <div class="card-header border-0">
        <h5 class="card-title font-bold py-3">آیتم های درخواستی</h5>
        <div style="flex: 1"></div>
      </div>
      <div class="p-5">
        <b-table
          id="main-table"
          bordered
          striped
          :fields="fields"
          :items="store_contradiction_items"
        >
          <template #cell(index)="data">
            {{ data.index + 1 }}
          </template>
          <template v-slot:cell(created_at)="data">
            {{ data.item.created_at | persianDate }}
          </template>
        </b-table>
      </div>
    </div>
    <div
      class="card mt-3"
      v-if="
        store_contradiction_forgotten_items &&
          store_contradiction_forgotten_items.length
      "
    >
      <div class="card-header border-0">
        <h5 class="card-title font-bold py-3">آیتم های فراموش شده</h5>
        <div style="flex: 1"></div>
      </div>
      <div class="row mt-2">
        <table class="table table-bordered table-hover">
          <thead>
            <tr>
              <th>ردیف</th>
              <th>شناسه</th>
              <th>محصول</th>
            </tr>
          </thead>
          <tbody>
            <tr
              v-for="(variety, index) in store_contradiction_forgotten_items"
              :key="index"
            >
              <td>
                <span>{{ index + 1 }}</span>
              </td>
              <td>
                <span>{{ variety.id }}</span>
              </td>
              <td>
                <span>{{ variety.variety.title }}</span>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  </main>
</template>
<script>
import {
  BTable,
  BFormGroup,
  BFormInput,
  BTr,
  BTd,
  BButton,
  BModal,
} from "bootstrap-vue";
import DatePickerRange from "@@/core/components/shared/DatePickerRange/DatePickerRange";
import ShowVarietiesModal from "@@/core/components/report/ShowVarietiesModal";
import configProvider from "@@/core/configProvider";
import Back from "@@/core/components/shared/Back/Back";

export default {
  name: "ContradictionsShow",
  components: {
    ShowVarietiesModal,
    DatePickerRange,
    BTable,
    BFormGroup,
    BFormInput,
    Back,
    BTr,
    BTd,
    BButton,
    BModal,
  },
  configProvider,
  data() {
    return {
      items: [],
      store_contradiction: {},
      store_contradiction_items: [],
      store_contradiction_forgotten_items: [],
      index: 1,
      fields: [
        {
          key: "index",
          label: "ردیف",
        },
        {
          key: "variety.title",
          label: "محصول",
        },
        {
          key: "store_balance",
          label: "موجودی انبار",
        },
        {
          key: "request_balance",
          label: "تعداد درخواست ها",
        },
        {
          key: "created_at",
          label: "تاریخ ثبت",
        },
      ],
      id: this.$route.params.id,
    };
  },
  mounted() {
    this.loadData();
  },
  methods: {
    async loadData() {
      try {
        const response = await this.$axios.get(
          "admin/store-contradictions/" + this.id,
        );
        this.items = response.data.data;
        this.store_contradiction = response.data.data.store_contradiction;
        this.store_contradiction_items =
          response.data.data.store_contradiction_items;
        this.store_contradiction_forgotten_items =
          response.data.data.store_contradiction_forgotten_items;
      } catch (e) {
        this.$root.notify(e);
      }
    },
  },
};
</script>
<style></style>
